import axios from "axios";

const urlCreate = '/rest/like/manage/create';
const urlDelete = '/rest/like/manage/delete';

export const likeHandlers = () => {
    $('.contest-like').click(function () {
        const container = $(this);

        const url = +container.data('active') == 1 ? urlDelete : urlCreate;

        axios.post(url, {entityId: $(this).data('id'), entityType: $(this).data('type')})
            .then((response) => {
                if (response.data.redirect !== undefined) {
                    window.location.href = response.data.redirect;

                    return;
                }

                if (response.data.active !== undefined) {
                    container.data('active', +response.data.active);
                }

                if (response.data.count !== undefined) {
                    container.find('.contest-like__count').text(parseInt(response.data.count));
                }
            });
    });
};
